import { get } from '@/server/axios'
// 级联树查询
function tree_get(params, option) {
  return get(
    `${process.env.VUE_APP_CASCADE_CONFIG}/cascade-config/tree`,
    params,
    option
  ).then(response => response)
}
export const cascadeConfig = {
  tree_get
}
